import {useEffect} from "react";
import {useFormContext} from "react-hook-form";

import {InputField} from "@/components/form/fields/InputField/InputField.tsx";
import {ServerErrors} from "@/lib/types/common.ts";
import {IntegrationFormData} from "@/lib/types/integrations.ts";
import {SetupInfo} from "@/pages/integrations/edit/subForms/components/SetupInfo.tsx";
import {IntegrationModuleInfo, IntegrationModules} from "@/pages/integrations/integrations.types.ts";

export type FormValuesKey = keyof IntegrationFormData;

interface PushBulletFormProps {
  serverErrors?: ServerErrors;
}

export const PushBulletForm = ({serverErrors}: PushBulletFormProps) => {
  const {setError} = useFormContext();

  useEffect(() => {
    if (serverErrors) {
      Object.keys(serverErrors)
        .filter((k) => k !== "__all__")
        .forEach((key) => setError(`settings.${key}` as FormValuesKey, {message: serverErrors[key][0]}));
    }
  }, [setError, serverErrors]);

  return (
    <>
      <div className="row row-cols-2 mb-3">
        <div className="col-12 mb-3">
          <InputField
            name="settings.email"
            label="Pushbullet Email"
            required={true}
            tooltip="The email used in creating your Pushbullet account."
            autoFocus={true}
          />
        </div>
      </div>
      <SetupInfo>
        <div className="p-2">
          To setup Pushbullet, use the email address associated with the Google or Facebook account you used to create
          your Pushbullet account, and enter it into the "Pushbullet Email" box above.
        </div>
        <div className="p-2">
          <a target="_blank" href="https://support.uptime.com/hc/en-us/articles/115002536349-Configuring-Pushbullet">
            View {IntegrationModuleInfo[IntegrationModules.PUSHBULLET].label} Support Article &rarr;
          </a>
        </div>
      </SetupInfo>
    </>
  );
};
